import { useState, useEffect } from "react";
import FileInput from "../FileInput/FileInput";
import AvatarPicker from "./AvatarPicker";

import "./styles/AvatarPicker.sass";
import Button from "../Button/Button";

interface IProps {
    value: string;
    setValue: (blob: Blob | null) => void;
}

const AvatarPickerLogic = ({ value = "", setValue }: IProps) => {
    const [image, setImage] = useState<string>(value);

    return (
        <div className="avatar-picker__wrapper">
            <input type="hidden" name="avatar" />

            {typeof image == "string" &&
                image !== "" &&
                !image.includes("blob") && (
                    <div className="avatarpicker_current">
                        <p>Current avatar: </p>
                        <img src={`${image}`} />

                        <Button preset="secondary" fn={() => setImage("")}>
                            Change image
                        </Button>
                    </div>
                )}
            {typeof image == "string" && image.includes("blob") && (
                <AvatarPicker
                    image={image}
                    resetImage={() => setImage("")}
                    setAvatar={setValue}
                    canvasWidth={340}
                    canvasHeight={340}
                />
            )}
            {image == "" && (
                <>
                    <FileInput
                        inputName="avatar"
                        parentFunction={(file: File) =>
                            setImage(URL.createObjectURL(file))
                        }
                        hideLabel={true}
                    />
                </>
            )}
        </div>
    );
};
export default AvatarPickerLogic;
